export const patientUser = {
  welcomeMessageFailed: "Sorry, there was an error sending the welcome message",
  patientEmailTaken: "Sorry, this patient email has already been taken",
  patientUserError: "Sorry, there was an error creating the patient user",
  patientUserUpdateError: "Sorry, there was an error updating the patient user"
};
